module.exports = __webpack_public_path__ + "img/81.3d5d78ea.jpg";